import React, { useEffect, useRef, useState } from "react";
import "stylesheets/header.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Images } from "constants/Images";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import ContactSaleModal from "./modal/ContactSaleModal";
import search from "../assets/icons/search.png";
import { useAuthContext } from "context/auth/AuthContext";
import userImg from "../assets/images/user.svg";
// import { chevronDown } from 'react-feather';
import { AiOutlineCaretDown, AiOutlineCaretUp } from "react-icons/ai";
import { API } from "API/API";
import { toast } from "react-toastify";
import { useSearchContext } from "context/searchContext/searchContext";
import { useForm } from "react-hook-form";
import cross from "assets/icons/cross.svg";
import classes from "./header.module.scss";
import { IoIosArrowForward } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";
import { CgClose } from "react-icons/cg";
import TranslateComponent from "./TranslateComponent";

const mainMenuList = [
  { label: "Home", path: "/" },
  { label: "Calculator", path: "/calculator" },
  { label: "Projects", path: "/projects" },
  { label: "Products", path: "/products" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

const menuList = [
  { label: "Get Started", path: "/login-signup", form: "signup" },
  { label: "Login", path: "/login-signup", form: "login" },
];

const SearchBar = ({ close, searchBar, handleSeachFilter }) => {
  const [showSearch, setShowSearch] = useState();
  const handleClose = () => {
    close();
    setShowSearch(false);
  };
  return (
    <div
      className={`${classes.searchbar} ${showSearch ? classes["searchbar--active"] : null
        }`}
    >
      <input
        type="text"
        value={searchBar}
        onChange={handleSeachFilter}
        placeholder="Search here..."
      />
      <span onClick={() => (searchBar ? handleClose() : setShowSearch(true))}>
        {searchBar ? <CgClose /> : <IoSearchOutline />}
      </span>
    </div>
  );
};

const Header = ({ onMenuOpen, isOpen }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState();
  const [showModal, setShowModal] = useState(false);
  const { login, doLogin, assignToken, token } = useAuthContext();
  let [tokenn, setTokenn] = useState(null);
  const { userData } = useSearchContext();
  const [searchBar, setSearchBar] = useState("");
  const [AlldATA, setAlldATA] = useState(userData);
  const { call, callUserApi } = useSearchContext();
  const { setSearch, seachField } = useSearchContext();
  const { handleSubmit, control, setValue, getValue } = useForm({});
  const location = useLocation();
  const param = useParams();
  const [isScrolled, setIsScrolled] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [userMenu, setUserMenu] = useState(false);

  const getToken = () => {
    let myToken = localStorage.getItem("mytoken");
    if (myToken) {
      setTokenn(myToken);
      return myToken;
    } else return null;
  };

  useEffect(() => {
    if (!location?.pathname?.includes("/products")) {
      setSearchBar("");
      setSearch("");
    }
  }, [location?.pathname]);

  const contactSalesRep = async (data) => {
    setLoader(true);
    try {
      let response = await API.contactSalesRep(data);
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
      setShowModal(false);
    }
  };

  useEffect(() => {
    getToken();
  }, [login, tokenn]);

  const onProjectClick = (item) => {
    const isLoggedIn = localStorage.getItem("mytoken");
    console.log("itemized", isLoggedIn, !isLoggedIn);

    if (item?.label === "Calculator") {
      // Handle Calculator navigation
      if (!isLoggedIn || isLoggedIn === "null" || isLoggedIn === "undefined") {
        navigate("/createProjectForm"); // Not logged in - go to createProjectForm
      } else {
        navigate("/createQuotationProjectForm"); // Logged in - go to createQuotationProjectForm
      }
      return;
    }
    if (!isLoggedIn) {
      navigate("login-signup");
    } else {
      item?.label === "Quotation"
        ? navigate("createQuotationProjectForm")
        : navigate("/projects");
    }
  };

  const isLoggedIn = () => {
    const token = localStorage.getItem("mytoken");
    return token && token !== "null" && token !== "undefined";
  };

  const onModalClick = () => {
    setShowModal(true);
  };
  const onLogin = () => {
    navigate("/login-signup");
  };
  const onLogout = () => {
    assignToken(null);
    doLogin(false);
    setTokenn(null);
    localStorage.removeItem("mytoken");
    localStorage.removeItem("token");
    toast.success("You have been logged out successfully");
    navigate("/login-signup");
  };
  const onLogoClick = () => {
    navigate("/");
  };

  // const handleSeachFilter = (e) => {
  //   setSearchBar(e.target.value)
  //   debounceTimer = setTimeout(() => {
  //     setSearch(e.target.value);
  //     if (!location.pathname.includes("createSubmittal") && !location.pathname.includes("createBrochure")) {
  //       navigate("/products");
  //     }
  //   }, 1000);
  // };

  // const debounceTimerRef = useRef(null);

  // const handleSeachFilter = (e) => {
  //   const value = e.target.value;
  //   setSearchBar(value);

  //   if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);

  //   debounceTimerRef.current = setTimeout(() => {
  //     setSearch(value);

  //     const isCreate = location.pathname.includes("createSubmittal") || location.pathname.includes("createBrochure");

  //     if (!isCreate && location.pathname !== "/products") {
  //       navigate("/products", { replace: true }); // 👈 doesn't push history
  //     }
  //   }, 1000);
  // };

  const debounceTimerRef = useRef(null);
  const hasNavigatedRef = useRef(false); // 🧠 New

  const handleSeachFilter = (e) => {
    const value = e.target.value;
    setSearchBar(value);

    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);

    debounceTimerRef.current = setTimeout(() => {
      setSearch(value);

      const isCreate =
        location.pathname.includes("createSubmittal") ||
        location.pathname.includes("createBrochure");

      if (!isCreate && location.pathname !== "/products") {
        if (!hasNavigatedRef.current) {
          navigate("/products");
          hasNavigatedRef.current = true;
        }
      }
    }, 1000);
  };

  useEffect(() => {
    if (location.pathname !== "/products") {
      hasNavigatedRef.current = false;
    }
  }, [location.pathname]);

  const EDITprofile = () => {
    navigate("/edit-profile");
  };
  const resetPas = () => {
    navigate("/change-password");
  };

  const crossSearch = () => {
    setSearchBar("");
    setSearch("");
  };

  // Modify header for home and products
  const modifyHeader = ["/", "/products"];
  const resetHeader = modifyHeader.includes(location.pathname);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const header = document?.querySelector('.header__modify');
  //     const isHeaderSticky = header?.classList?.contains('header__modify--sticky');
  //     if (window.scrollY > 100 && !isHeaderSticky) {
  //       setIsScrolled(true);
  //     } else if (window.scrollY < 100 && isHeaderSticky) {
  //       setIsScrolled(false);

  //     }
  //   };
  //   // Add event listener when the component mounts
  //   window.addEventListener('scroll', handleScroll);
  //   // Remove event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined")
      return;

    const handleScroll = () => {
      const header = document.querySelector(".header__modify");
      const isHeaderSticky = header?.classList.contains(
        "header__modify--sticky"
      );

      if (window.scrollY > 100 && !isHeaderSticky) {
        setIsScrolled(true);
      } else if (window.scrollY < 100 && isHeaderSticky) {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger scroll check on mount in case already scrolled
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY >= 10);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <React.Fragment>
      <header
        className={`${classes.header} ${location.pathname === "/" && classes.stopTop
          } ${scrolled && classes["header__sticky"]}`}
      >
        <div className="container">
          <div className={classes.header__bg}>
            <div className={classes.header__logo}>
              <img
                src={Images.image.logo}
                alt="logo"
                onClick={() => navigate("/")}
              />
            </div>

            <div
              className={`${classes.header__menu} ${isOpen ? classes.show : null
                }`}
            >
              <ol>
                {mainMenuList
                  .filter(item => {
                    if (!isLoggedIn() && (item.label === "Projects")) {
                      return false;
                    }
                    return true;
                  })
                  .map((item, idx) => (
                    <li
                      key={idx}
                      // className={
                      //   item.path === location.pathname && classes.active
                      // }
                      className={
                        (item.path === location.pathname ||
                          (item.label === "Calculator" &&
                            (location.pathname === "/createProjectForm" ||
                              location.pathname === "/createQuotationProjectForm")))
                          ? classes.active
                          : ""
                      }
                      onClick={() => {
                        if (
                          item.label === "Projects" ||
                          // item.label === "Quotation"
                          item.label === "Calculator"
                        ) {
                          onProjectClick(item);
                          return;
                        }
                        onMenuOpen();
                        return navigate(item.path);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {item.label}
                    </li>
                  ))}
              </ol>
              <div className={classes.desktop}>
                <SearchBar
                  close={crossSearch}
                  searchBar={searchBar}
                  handleSeachFilter={handleSeachFilter}
                />
              </div>
              {(localStorage.getItem("mytoken") === undefined ||
                localStorage.getItem("mytoken") === "null" ||
                localStorage.getItem("mytoken") === null) &&
                !login ? (
                <ul>
                  {menuList.map((item, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        navigate(item.path, { state: { formType: item.form } });
                        onMenuOpen();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {item.label}
                      {menuList.length - 1 !== idx && (
                        <span>
                          <IoIosArrowForward />
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
            <div className={classes.mobile}>
              <SearchBar
                close={crossSearch}
                searchBar={searchBar}
                handleSeachFilter={handleSeachFilter}
              />
            </div>
            {(localStorage.getItem("mytoken") === undefined ||
              localStorage.getItem("mytoken") === "null" ||
              localStorage.getItem("mytoken") === null) &&
              !login ? null : (
              <div className={classes.dropdown}>
                <div
                  className={`${classes.dropdown__btn} ${userMenu && classes["dropdown__btn--active"]
                    }`}
                  onClick={() => setUserMenu((prev) => !prev)}
                >
                  <img src={userImg} alt={userData?.firstname} />
                  <span>{userData?.firstname}</span>
                  <AiOutlineCaretDown />
                </div>
                {userMenu && (
                  <div className={classes.dropdown__menu}>
                    <span
                      className="leftMargin"
                      onClick={() => {
                        EDITprofile();
                        setUserMenu(false);
                      }}
                    >
                      Edit Profile
                    </span>
                    <span
                      className="leftMargin"
                      onClick={() => {
                        resetPas();
                        setUserMenu(false);
                      }}
                    >
                      Change Password
                    </span>
                    <span
                      onClick={() => {
                        onLogout();
                        setUserMenu(false);
                      }}
                    >
                      Log Out
                    </span>
                  </div>
                )}
              </div>
            )}
            {/* <TranslateComponent /> */}
            {/* <div className={classes.header__translate}>
              <div id="google_translate_element"></div>
            </div> */}
            <button
              className={`${classes.header__menuBtn}  ${isOpen ? classes.show : null
                }`}
              type="button"
              onClick={onMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      <ContactSaleModal
        click={() => setShowModal(!showModal)}
        show={showModal}
        contact={contactSalesRep}
        loader={loader}
      />
    </React.Fragment>
  );
};
export default Header;
